import { createContext } from "react";
export var TreeViewDescendantContext = createContext({
  parentPath: []
});